import { trackEvent } from 'dibs-tracking';
import { mutations } from '../constants';

const trackFavoritesEvent = ({
    action,
    type = 'item',
    shouldTrackReordering = false,
    setShouldTrackReordering,
    itemCount,
    hasNote = false,
}) => {
    let eventAction = `${type} favoriting bulk updates`;
    let eventCategory = `item favoriting`;
    let eventLabel;
    let value = 0;

    switch (action) {
        case mutations.types.REMOVE:
            eventLabel = `${type}(s) favorites deleted`;
            break;
        case mutations.types.ADD:
            if (type === 'folder') {
                eventAction = 'item favoriting folder created';
                eventLabel = 'my favorites';
            } else {
                eventLabel = 'item favorites added to folder';
            }
            break;
        case mutations.types.EDIT:
            eventLabel = 'item notes added';
            break;
        case mutations.types.REORDER:
            if (shouldTrackReordering) {
                setShouldTrackReordering(false);
                eventLabel = `${type} favoriting re-arranged`;
            }
            break;
        case mutations.types.SHARE:
            eventAction = 'email a friend sent';
            eventCategory = 'email a friend';
            eventLabel = type;

            if (type === 'item' && itemCount > 1) {
                eventLabel = 'multiple items';
            }
            if (hasNote) {
                value = 1;
            }

            break;
    }

    if (eventLabel) {
        trackEvent({
            action: eventAction,
            label: eventLabel,
            category: eventCategory,
            value,
        });
    }
};

export default trackFavoritesEvent;
